import ApiService from "@/services/api";
import { getError } from "@/util";

export const state = {
  user: null,
  loading: false,
  error: null
};
export const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_MESSAGE(state, message) {
    state.message = message;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};
export const actions = {
  logout({ commit }) {
    return ApiService.auth
      .logout()
      .then(() => {
        commit("SET_USER", null);
        commit("CLEAR_CART");
      })
      .catch(error => {
        commit("SET_ERROR", getError(error));
      });
  },
  getAuthUser({ commit }) {
    commit("SET_LOADING", true);
    return ApiService.user
      .getAuthed()
      .then(response => {
        commit("SET_USER", response.data.data.user);
        commit("SET_LOADING", false);
      })
      .catch(error => {
        commit("SET_LOADING", false);
        commit("SET_USER", null);
        commit("SET_ERROR", getError(error));
      });
  }
};
export const getters = {
  authUser: state => {
    return state.user;
  },
  isAdmin: state => {
    return state.user.isAdmin;
  },
  error: state => {
    return state.error;
  },
  loading: state => {
    return state.loading;
  },
  loggedIn: state => {
    return !!state.user;
  }
};
